var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50022 0C3.70597 0 0.619141 3.08683 0.619141 6.88104C0.619141 11.5898 6.77703 18.5025 7.03921 18.7945C7.28547 19.0687 7.71542 19.0682 7.96123 18.7945C8.22341 18.5025 14.3813 11.5898 14.3813 6.88104C14.3812 3.08683 11.2944 0 7.50022 0ZM7.50022 10.3431C5.59124 10.3431 4.03821 8.79002 4.03821 6.88104C4.03821 4.97206 5.59128 3.41904 7.50022 3.41904C9.40916 3.41904 10.9622 4.9721 10.9622 6.88108C10.9622 8.79006 9.40916 10.3431 7.50022 10.3431Z",
    fill: "#FDCB00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.e1672a1c2de76fe837105b25a3dcb28d.svg";
export { ForwardRef as ReactComponent };